import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableItem from '../../models/TableItem';
import TableHeader from '../../models/TableHeader';
import Pagination from './PaginatedLinks';
import TableCell from './TableCell';

export class PaginatedTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
        };

        this.setPageHandler = this.setPageHandler.bind(this);
    }

    /**
     * Handles previous page event, and sets the current page to previous page.
     *
     * @param {Number} pageNumber
     *
     * @return {void}
     */
    setPageHandler(pageNumber) {
        this.setState({
            currentPage: pageNumber,
        });
    }

    /**
     * Page change callback to handle page changes and update filtered content.
     *
     * @return {Array}
     */
    getCurrentPageRows() {
        const {
            rows,
            perPage,
        } = this.props;

        const {
            currentPage,
        } = this.state;

        const endIndex = perPage * currentPage;
        const startIndex = endIndex - perPage;

        return rows.slice(startIndex, endIndex);
    }

    /**
     * Renders the component.
     *
     * @return {JSX}
     */
    render() {
        const {
            headers,
            rows,
            perPage,
            pageRange,
            className,
        } = this.props;

        const {
            currentPage,
        } = this.state;

        const headersView = headers.map(header => (
            <th key={ `header-${header.key}` } id={ `header-${header.key}` }>
                { header.value }
            </th>
        ));

        const tableView = this.getCurrentPageRows().map((row, rowIndex) => (
            <tr key={ `row-${currentPage}-${rowIndex}` }>
                {
                    row.map(rowItem => (
                        <TableCell
                            hasError={ rowItem.hasError }
                            errorMessage={ rowItem.errorMessage }
                            key={ `item-${rowItem.attribute}-${rowIndex}` }
                            id={ `item-${rowItem.attribute}-${rowIndex}` }
                            content={ rowItem.value }
                        />
                    ))
                }
            </tr>
        ));

        return (
            <div>
                <table className={ `table--striped ${className}` }>
                    <thead>
                        <tr>
                            { headersView }
                        </tr>
                    </thead>
                    <tbody>
                        { tableView }
                    </tbody>
                </table>

                <div className="grid m-t-xxs">
                    <div className="grid__col grid__col-md-4">
                        <Pagination
                            setPageHandler={ this.setPageHandler }
                            totalRows={ rows.length }
                            perPage={ perPage }
                            currentPage={ currentPage }
                            pageRange={ pageRange }
                        />
                    </div>

                    <div className="grid__col grid__col-md-8 text-right">
                        { this.props.children }
                    </div>
                </div>
            </div>
        );
    }
}

PaginatedTable.propTypes = {
    rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape(TableItem))).isRequired,
    perPage: PropTypes.number,
    pageRange: PropTypes.number,
    className: PropTypes.string,
    headers: PropTypes.arrayOf(PropTypes.shape(TableHeader)).isRequired,
    children: PropTypes.arrayOf(PropTypes.element),
};

PaginatedTable.defaultProps = {
    perPage: 10,
    pageRange: 5,
    children: [],
    className: '',
};

export default PaginatedTable;
